import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import PropTypes from 'prop-types';
import { Modal, Form, Select, Icon, Button } from 'antd';
import _ from 'lodash';
import BaseTemplateForm from '../BaseTemplateForm';
import './CreateAryabotTemplate.scss';
import message from '../../../../Containers/CandidateDrawer/messages';
import QuestionItemContainer from '../../QuestionItemContainer/QuestionItemContainer';
import { BotQuestionsMixin } from '../BotQuestionsMixin';

class CreateAryabotTemplate extends BaseTemplateForm {
  constructor(props) {
    super(props);
    const initialState = BotQuestionsMixin.initializeBotQuestions(_.get(props, ['initialValues', 'Questions'], []));
    this.state = {
      botQuestions: [],
      dragQuestionId: -1,
      ...initialState,
    };
    this.lastQuestionRef = React.createRef();
  }

  static getDerivedStateFromProps(props, state) {
    const propsQuesions = _.get(props, ['initialValues', 'Questions'], []);
    const newState = _.clone(state);
    if (!_.isEqual(_.get(props, ['initialValues', 'Questions'], []), state.propsQuesions)) {
      const initialState = BotQuestionsMixin.initializeBotQuestions(props.questions || []);
      return {
        ...state,
        botQuestions: _.get(props, ['initialValues', 'Questions'], []),
        showFollowupQuestions: initialState.showFollowupQuestions,
        propsQuesions,
      };
    }

    return newState;
  }

  addQuestion = order => {
    const { botQuestions } = this.state;
    const { isPaidJobServiceEnabled } = this.props;
    const updatedQuestions = BotQuestionsMixin.addQuestion.call(this, botQuestions, order, isPaidJobServiceEnabled);
    this.setState({
      botQuestions: updatedQuestions,
    });
  };

  removeQuestion = order => {
    const { botQuestions, showFollowupQuestions } = this.state;
    const { updatedQuestions, removedOrders, orderUpdateMapper } = BotQuestionsMixin.removeQuestion(
      botQuestions,
      order
    );
    const { updatedShowFollowupQuestions } = BotQuestionsMixin.updateOrderForRemove(
      { showFollowupQuestions },
      removedOrders,
      orderUpdateMapper
    );
    this.setState(
      {
        botQuestions: updatedQuestions,
        showFollowupQuestions: updatedShowFollowupQuestions,
      },
      this.validateForm
    );
  };

  onQuestionFieldChange = (field, order, value) => {
    const { botQuestions, categoryErrors, questionErrors } = this.state;
    const updatedQuestions = BotQuestionsMixin.onQuestionFieldChange(botQuestions, field, order, value);
    const clonedCategoryErrors = { ...categoryErrors };
    const clonedQuestionErrors = { ...questionErrors };
    if (value?.trim() && field === 'CategoryName') {
      delete clonedCategoryErrors[order];
    }
    if (value?.trim() && field === 'Question') {
      delete clonedQuestionErrors[order];
    }
    if (!value?.trim() && field === 'CategoryName') {
      clonedCategoryErrors[order] = true;
    }
    if (!value?.trim() && field === 'Question') {
      clonedQuestionErrors[order] = true;
    }
    this.setState({
      botQuestions: updatedQuestions,
      categoryErrors: clonedCategoryErrors,
      questionErrors: clonedQuestionErrors,
    });
  };

  getSelectTemplateItem(label) {
    const { form } = this.props;
    return (
      <Form.Item label={label} colon={false}>
        {form.getFieldDecorator('template')(<Select />)}
      </Form.Item>
    );
  }

  moveQuestions = (dragIndex, hoverIndex) => {
    const { botQuestions } = this.state;
    const { orderUpdateMapper } = BotQuestionsMixin.moveQuestions(botQuestions, dragIndex, hoverIndex);
    if (Object.keys(orderUpdateMapper).length > 0) {
      this.updateOrder(orderUpdateMapper);
    }
  };

  updateOrder = orderUpdateMapper => {
    const { botQuestions } = this.state;
    const { updatedQuestions, showFollowupQuestions } = BotQuestionsMixin.updateOrder(botQuestions, orderUpdateMapper);
    this.setState(
      {
        botQuestions: updatedQuestions,
        showFollowupQuestions,
      },
      this.validateForm
    );
  };

  updateDragQuestionId = (type, dragQuestionId) => {
    this.setState({ dragQuestionId });
  };

  collapseFollowupQuestions = (questionOrder, status) => {
    const { showFollowupQuestions } = this.state;
    const updatedStatus = BotQuestionsMixin.collapseFollowupQuestions(showFollowupQuestions, questionOrder, status);
    this.setState({
      showFollowupQuestions: updatedStatus,
    });
  };

  collapseAllFollowupQuestions = () => {
    const { showFollowupQuestions } = this.state;
    const updatedStatus = BotQuestionsMixin.collapseAllFollowupQuestions(showFollowupQuestions, false);
    this.setState({
      showFollowupQuestions: updatedStatus,
    });
  };

  expandAllFollowupQuestions = () => {
    const { showFollowupQuestions } = this.state;
    const updatedStatus = BotQuestionsMixin.collapseAllFollowupQuestions(showFollowupQuestions, true);
    this.setState({
      showFollowupQuestions: updatedStatus,
    });
  };

  validateForm = () => {
    const { botQuestions } = this.state;
    const { hasErrors, categoryErrors, questionErrors } = BotQuestionsMixin.validateForm(botQuestions);
    this.setState({
      categoryErrors,
      questionErrors,
    });
    return hasErrors;
  };

  updateCollapseOfQuestions = showFollowupQuestions => {
    this.setState({
      showFollowupQuestions,
    });
  };

  getQuestions = () => {
    const { botQuestions, categoryErrors, questionErrors, showFollowupQuestions, dragQuestionId } = this.state;
    const { viewOnly } = this.props;

    const showQuestionItem = BotQuestionsMixin.renderQuestions(botQuestions, {
      categoryErrors,
      questionErrors,
      showFollowupQuestions,
      removeQuestion: this.removeQuestion,
      onCategoryChange: this.onCategoryChange,
      addQuestion: this.addQuestion,
      onQuestionFieldChange: this.onQuestionFieldChange,
      onDragQuestion: this.moveQuestions,
      collapseFollowupQuestions: this.collapseFollowupQuestions,
      readOnly: viewOnly,
      QuestionItemComponent: QuestionItemContainer,
      updateDragQuestionId: this.updateDragQuestionId,
      dragQuestionId,
      updateCollapseOfQuestions: this.updateCollapseOfQuestions,
    });

    return <div>{showQuestionItem}</div>;
  };

  onCategoryChange = (order, value) => {
    const { botQuestions, showFollowupQuestions } = this.state;
    const { updatedQuestions, removedOrders } = BotQuestionsMixin.removeChildQuestions(
      BotQuestionsMixin.onCategoryChange(botQuestions, order, value),
      order
    );
    const { updatedShowFollowupQuestions } = BotQuestionsMixin.updateOrderForRemove(
      { showFollowupQuestions },
      removedOrders,
      {}
    );
    updatedShowFollowupQuestions[order] = false;
    this.setState(
      {
        botQuestions: updatedQuestions,
        showFollowupQuestions: updatedShowFollowupQuestions,
      },
      this.validateForm
    );
  };

  onAddNewQuestionClick = () => {
    const { botQuestions } = this.state;
    const currentLastQuestionOrder = BotQuestionsMixin.getCurrentLastQuestionOrder(botQuestions);
    this.addQuestion(`${Number(currentLastQuestionOrder) + 1}`);
    setTimeout(() => {
      if (this.lastQuestionRef.current) {
        const modalBody = this.lastQuestionRef.current.closest('.ant-modal-body');
        if (modalBody) {
          modalBody.scrollTo({ top: modalBody.scrollHeight, behavior: 'smooth' });
        }
      }
    }, 10);
  };

  checkForError = () => {
    const { categoryErrors, questionErrors, botQuestions } = this.state;
    const { form } = this.props;
    return (
      Object.values(categoryErrors || {}).some(Boolean) ||
      Object.values(questionErrors || {}).some(Boolean) ||
      !botQuestions?.length ||
      !form.getFieldValue('template-name')?.trim()
    );
  };

  getFooter = () => {
    const { viewOnly, onClose } = this.props;
    const isSaveDisable = viewOnly || this.checkForError();
    return (
      <div className="bot-config-footer" style={{ alignItems: 'center', height: '65px' }}>
        <div>
          {!viewOnly && (
            <button type="button" className="add-question-button" onClick={this.onAddNewQuestionClick}>
              <Icon type="plus-circle" theme="outlined" className="add-question-icon" style={{ fontSize: '16px' }} />
              <FormattedMessage {...message.addQuestionsButton} />
            </button>
          )}
        </div>
        <div style={{ display: 'flex', gap: '15px' }}>
          <Button shape="round" onClick={onClose}>
            <FormattedMessage {...message.cancelLabel} />
          </Button>
          <Button onClick={this.saveTemplate} disabled={isSaveDisable} shape="round" type="primary">
            <FormattedMessage {...message.saveTemplateLabel} />
          </Button>
        </div>
      </div>
    );
  };

  saveTemplate = event => {
    const { onSubmit, initialValues, form } = this.props;
    const { botQuestions } = this.state;
    event.preventDefault();
    if (!this.validateForm()) {
      const isPublic = initialValues?.IsPublic ?? false;
      onSubmit(form.getFieldValue('template-name'), isPublic, botQuestions);
    } else {
      this.expandAllFollowupQuestions();
    }
  };

  render() {
    const { title, visible, initialValues, intl, onClose, viewOnly } = this.props;
    const { botQuestions } = this.state;

    return (
      <Modal
        className="create-template aryabot drawer"
        destroyOnClose
        title={title}
        placement="right"
        onCancel={onClose}
        visible={visible}
        bodyStyle={{ maxHeight: '68vh', overflowY: 'scroll', paddingBottom: '90px' }}
        width={900}
        footer={null}
      >
        <div ref={this.lastQuestionRef}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingBottom: '10px',
            }}
          >
            {this.getTemplateNameItem(
              intl.formatMessage({ ...message.aryaBotTemplateNameLabel }),
              intl.formatMessage({ ...message.pleaseInputTheTemplateName }),
              initialValues.Name
            )}
            <Button
              onClick={this.collapseAllFollowupQuestions}
              shape="round"
              disabled={viewOnly || !botQuestions?.length}
            >
              <FormattedMessage {...message.collapseAll} />
            </Button>
          </div>
          {this.getQuestions()}
          {this.getFooter()}
        </div>
      </Modal>
    );
  }
}

CreateAryabotTemplate.propTypes = {
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  initialValues: PropTypes.shape({}),
};

CreateAryabotTemplate.defaultProps = {
  initialValues: {},
};

export default DragDropContext(HTML5Backend)(injectIntl(Form.create()(CreateAryabotTemplate)));

export { CreateAryabotTemplate as CreateAryabotTemplateWithoutForm };
